import { PreRenderService } from './../services/pre-render.service';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ResponseService } from '../services/response/response.service';
import { Injectable } from '@angular/core';
import { CommunicationService } from '../services/communication.service';

@Injectable()
export class SetRouteCodeGuard implements CanActivate {
  constructor(private responseService: ResponseService,
    private communicationService: CommunicationService,
    private router: Router,
    private preRenderService: PreRenderService
    ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const HOMEESTIMATES = 'home-estimates';
    const currentRoute = route.url;

    if (currentRoute && currentRoute.length > 0 && currentRoute[0].path === HOMEESTIMATES) {
      this.router.navigate(['/home-estimates-canada']);
      this.preRenderService.setPreRenderFlag(301, '/home-estimates-canada');
      return true;
    }

    const routeCode = route.data ? route.data.routeCode : null;

    this.responseService.setRouteCode(routeCode);
    this.communicationService.activeRouteCode.next(route.data && route.data.routeCode ? route.data.routeCode : null);
    return true;
  }
}
